import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import { AppNotification } from '../../models/app-notification.model';
import { AdminService } from '../../services/admin.service';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-notification', template: `
  <a *ngIf="route" [href]="link" [attr.aria-disabled]="opening" (click)="open($event)">
    <ng-container *ngIf="messageKey; else legacyDescription">{{ messageKey | translate:notification.messageParams }}</ng-container>
    <ng-template #legacyDescription>
      {{ (notification.description | contentTranslation:notification.descriptionTranslation).trim() || ('NO_DESCRIPTION' | translate) }}
    </ng-template>
    <span *ngIf="itemTitleKey"> · {{ itemTitleKey | translate }}</span>
    <span *ngIf="!itemTitleKey && stageTitleKey"> · {{ stageTitleKey | translate }}</span>
    <span *ngIf="recordedAt"> · {{ recordedAt | date:'dd.MM.yyyy HH:mm' }}</span>
  </a><p *ngIf="readError" role="alert">{{ 'offboarding.notifications.openFailed' | translate }}</p>`,
  styles: ['a {display:inline-block; padding:8px 0; white-space:normal;} a:focus {outline:2px solid #176fa1;}']})
export class OffboardingNotificationComponent implements OnChanges, OnDestroy {
  @Input() notification: AppNotification;
  route: string[];
  query: {stage?: string};
  itemTitleKey: string;
  stageTitleKey: string;
  recordedAt: string;
  messageKey: string;
  link: string;
  opening = false;
  readError = false;
  private request: Subscription;
  private destroyed = new Subject<void>();
  constructor(private admin: AdminService, private router: Router) {}
  ngOnChanges(): void {
    if (this.request) { this.request.unsubscribe(); }
    this.opening = false; this.readError = false;
    this.route = this.notification.caseId ? [O.route, this.notification.caseId] : null;
    this.query = {stage: this.notification.stageKey};
    this.link = this.route ? this.router.serializeUrl(this.router.createUrlTree(this.route, {queryParams: this.query})) : null;
    const params = this.notification.messageParams || {};
    this.itemTitleKey = <string>params.itemTitleKey; this.stageTitleKey = <string>params.stageTitleKey;
    this.recordedAt = <string>params.recordedAt;
    this.messageKey = this.notification.messageKey && this.notification.eventType === NOTIFICATION.task && (this.notification.actionResolved || this.notification.actionRequired === false)
      ? NOTIFICATION.resolved : this.notification.messageKey;
  }
  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }
  open(event: Event): void {
    event.preventDefault(); event.stopPropagation();
    if (!this.route || this.opening) { return; }
    const notification = this.notification;
    if (notification.viewed || notification.eventType === NOTIFICATION.task && notification.actionRequired && !notification.actionResolved) {
      this.router.navigate(this.route, {queryParams: this.query}); return;
    }
    this.opening = true; this.readError = false;
    this.request = this.admin.notifyIsView({id: notification.id, notificationCategory: NOTIFICATION.category})
      .take(NOTIFICATION.responseCount).takeUntil(this.destroyed).subscribe(() => {
        if (this.notification !== notification) { return; }
        this.opening = false; notification.viewed = true; this.router.navigate(this.route, {queryParams: this.query});
      }, () => { this.opening = false; this.readError = true; });
  }
}
const NOTIFICATION = {task: 'TASK', resolved: 'offboarding.notifications.RESOLVED_TASK', category: 'NOTIFICATION_GENERAL', responseCount: 1};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-notification.component.ts